import { ChipSize } from '../../Chip';
import { tokens as chipTokens } from '../../Chip/tokens';

const BORDER_GRADIENT =
    'linear-gradient(240.45deg, rgba(255, 255, 255, 0.4) -6.9%, rgba(255, 255, 255, 0) 26.62%) border-box, linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0) 100%) border-box';

const gutter = 2;

const minHeight = Object.entries(chipTokens.chip.height).reduce((collection, [key, value]) => {
    return {
        ...collection,
        [key]: value - gutter * 2,
    };
}, {});

export const tokens = {
    wrapper: {
        background: `linear-gradient(180deg, #232131 0%, #0D0B0E 100%) padding-box,
        ${BORDER_GRADIENT}`,
        gutter,
        minHeight,
    },
    yat: {
        fontSize: {
            [ChipSize.Smaller]: 12,
            [ChipSize.Small]: 16,
            [ChipSize.Medium]: 20,
            [ChipSize.Large]: 26,
        },
    },
};
